import React from "react";
import "./Sticker.css";

const Sticker = () => {
  return (
    <>
      <section className="stickerSection">
        <div className="scroll">
          <div>
            <ul className="tag-list scroller__inner">
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
              <li>humanizing technology</li>
              <li>•</li>
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
            </ul>
          </div>
          <div>
            <ul className="tag-list scroller__inner">
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
              <li>humanizing technology</li>
              <li>•</li>
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
              <li>humanizing technology</li>
              <li className="bullet-point">•</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default Sticker;
